module.exports = __webpack_public_path__ + "static/img/13-Tokamak-energy.44bfb99c.jpg";